module.exports = "<div ng-if=restrictUi.asInternalFeature()> What is your current setup in regards to [assist_with_accounting_admin_work]? ... </div>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/current-setup-assist-with-accounting-admin-work.html
// module id = 1712
// module chunks = 86